module.exports = __webpack_public_path__ + "img/WP23-volunteers2.7c1c641d.jpg";